(() => {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const lockBody = (locked) => document.body.classList.toggle('is-locked', locked);

  const menu = qs('[data-mobile-menu]');
  const menuOpen = qs('[data-menu-open]');
  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    menuOpen?.setAttribute('aria-expanded', 'false');
    lockBody(false);
  };
  menuOpen?.addEventListener('click', () => {
    qsa('img[data-menu-src]', menu || document).forEach((image) => {
      image.src = image.dataset.menuSrc;
      delete image.dataset.menuSrc;
    });
    menu?.classList.add('is-open');
    menu?.setAttribute('aria-hidden', 'false');
    menuOpen.setAttribute('aria-expanded', 'true');
    lockBody(true);
  });
  qsa('[data-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));

  const filterDrawer = qs('[data-filter-drawer]');
  const closeFilters = () => {
    filterDrawer?.classList.remove('is-open');
    filterDrawer?.setAttribute('aria-hidden', 'true');
    lockBody(false);
  };
  qs('[data-filter-open]')?.addEventListener('click', () => {
    filterDrawer?.classList.add('is-open');
    filterDrawer?.setAttribute('aria-hidden', 'false');
    lockBody(true);
  });
  qsa('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilters));

  const toast = (message) => {
    const el = qs('#ThemeToast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    window.clearTimeout(window.__kaiToast);
    window.__kaiToast = window.setTimeout(() => el.classList.remove('is-visible'), 2600);
  };

  const askBuildAnotherJig = () => new Promise((resolve) => {
    const dialog = qs('#JigBuilderAddedDialog');
    if (!dialog?.showModal) {
      resolve(false);
      return;
    }

    const anotherButton = qs('[data-jig-dialog-another]', dialog);
    const keepButton = qs('[data-jig-dialog-keep]', dialog);
    const closeButton = qs('[data-jig-dialog-close]', dialog);
    let settled = false;

    const cleanup = () => {
      anotherButton?.removeEventListener('click', onAnother);
      keepButton?.removeEventListener('click', onKeep);
      closeButton?.removeEventListener('click', onKeep);
      dialog.removeEventListener('cancel', onCancel);
      dialog.removeEventListener('click', onBackdrop);
    };

    const finish = (buildAnother) => {
      if (settled) return;
      settled = true;
      cleanup();
      if (dialog.open) dialog.close();
      resolve(buildAnother);
    };

    const onAnother = () => finish(true);
    const onKeep = () => finish(false);
    const onCancel = (event) => {
      event.preventDefault();
      finish(false);
    };
    const onBackdrop = (event) => {
      if (event.target === dialog) finish(false);
    };

    anotherButton?.addEventListener('click', onAnother);
    keepButton?.addEventListener('click', onKeep);
    closeButton?.addEventListener('click', onKeep);
    dialog.addEventListener('cancel', onCancel);
    dialog.addEventListener('click', onBackdrop);
    dialog.showModal();
  });

  const updateCartCount = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      qsa('.js-cart-count').forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
      });
    } catch (_) {}
  };

  qsa('.product-form, .hand-tie-builder__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const addButton = event.submitter?.matches?.('[data-add-to-cart]') ? event.submitter : qs('[data-add-to-cart]', form);
      if (!addButton) return;

      event.preventDefault();
      if (addButton.disabled) return;

      const addLabel = qs('[data-add-label]', addButton);
      const originalLabel = addLabel?.textContent || 'Add to cart';
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding...';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result?.description || 'Could not add product');

        await updateCartCount();
        toast('Added to your tackle box');
        if (addLabel) addLabel.textContent = 'Added ✓';

        const plasticBuilder = form.querySelector('custom-jig-builder');
        const handTieBuilder = form.querySelector('hand-tie-builder');
        const plasticCustomBuildFlag = plasticBuilder?.querySelector('[name="properties[_Custom Build]"]:not(:disabled)');
        const customBuilder = handTieBuilder || (plasticCustomBuildFlag ? plasticBuilder : null);

        if (customBuilder) {
          const buildAnother = await askBuildAnotherJig();

          if (buildAnother) {
            if (plasticBuilder) {
              plasticBuilder.querySelectorAll('[data-custom-color]').forEach((input) => { input.checked = false; });
              plasticBuilder.querySelectorAll('[data-custom-flake]').forEach((input) => { input.checked = input.value === 'None'; });
              plasticBuilder.querySelectorAll('[data-custom-interference]').forEach((input) => { input.checked = input.value === 'None'; });
              plasticBuilder.querySelectorAll('[data-custom-property]').forEach((input) => {
                if (input.hasAttribute('data-property-flake-first') || input.hasAttribute('data-property-flake-second') || input.hasAttribute('data-property-interference-first') || input.hasAttribute('data-property-interference-second')) input.value = 'None';
                else if (!input.hasAttribute('data-property-profile')) input.value = '';
              });
              const notes = plasticBuilder.querySelector('[data-custom-notes]');
              if (notes) notes.value = '';
              const selectedProfile = plasticBuilder.querySelector('[data-builder-profile]:checked');
              if (selectedProfile && typeof plasticBuilder.onProfileChange === 'function') plasticBuilder.onProfileChange(selectedProfile);
              if (typeof plasticBuilder.syncTadpoleFlakes === 'function') plasticBuilder.syncTadpoleFlakes();
              if (typeof plasticBuilder.syncStingerFlakes === 'function') plasticBuilder.syncStingerFlakes();
              if (typeof plasticBuilder.syncValidity === 'function') plasticBuilder.syncValidity();
            }

            if (handTieBuilder) {
              handTieBuilder.querySelectorAll('[data-color-part]').forEach((input) => { input.checked = false; });
              const materialProperty = handTieBuilder.querySelector('[data-material-property]');
              if (materialProperty) materialProperty.value = '';
              if (typeof handTieBuilder.syncColors === 'function') handTieBuilder.syncColors();
              if (typeof handTieBuilder.syncAvailability === 'function') handTieBuilder.syncAvailability();
            }

            const qty = form.querySelector('[data-qty-input]');
            if (qty) qty.value = 1;
            customBuilder.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          window.setTimeout(() => {
            if (addLabel) addLabel.textContent = originalLabel;
            addButton.disabled = false;
          }, 400);
        } else {
          window.setTimeout(() => {
            if (addLabel) addLabel.textContent = originalLabel;
            addButton.disabled = false;
          }, 1400);
        }
      } catch (error) {
        toast(error.message || 'Could not add product');
        if (addLabel) addLabel.textContent = originalLabel;
        addButton.disabled = false;
      }
    });
  });

  qs('[data-clear-cart]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Clearing...';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Could not clear cart');
      await updateCartCount();
      window.location.reload();
    } catch (error) {
      toast(error.message || 'Could not clear cart');
      button.disabled = false;
      button.textContent = originalText;
    }
  });

  qsa('[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = qs('button[type="submit"]', form);
      if (button) button.disabled = true;
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Could not add product');
        await updateCartCount();
        toast('Added to your tackle box');
      } catch (error) {
        toast(error.message || 'Could not add product');
      } finally {
        if (button) button.disabled = false;
      }
    });
  });

  qsa('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('[data-qty-input]');
    input.value = Math.max(1, Number(input.value || 1) - 1);
  }));
  qsa('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('[data-qty-input]');
    input.value = Number(input.value || 1) + 1;
  }));

  qsa('[data-media-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      const mediaId = button.dataset.mediaThumb;
      qsa('[data-media-id]', gallery).forEach((media) => media.classList.toggle('is-hidden', media.dataset.mediaId !== mediaId));
      qsa('[data-media-thumb]', gallery).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
    });
  });

  class VariantSelector extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      this.variants = JSON.parse(qs('[data-product-variants]', this)?.textContent || '[]');
      qsa('[data-option-value]', this).forEach((input) => input.addEventListener('change', () => this.onChange()));
    }
    selectedOptions() {
      return qsa('[data-option-index]', this).map((group) => qs('[data-option-value]:checked', group)?.value);
    }
    onChange() {
      qsa('[data-option-index]', this).forEach((group) => {
        const label = qs('[data-option-current]', group);
        const checked = qs('[data-option-value]:checked', group);
        if (label && checked) label.textContent = checked.value;
      });
      const selected = this.selectedOptions();
      const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
      this.updateVariant(variant);
    }
    updateVariant(variant) {
      const formId = qs('[data-variant-id]', this.root);
      const addButton = qs('[data-add-to-cart]', this.root);
      const stickyAdd = qs('[data-sticky-add]', this.root);
      if (!variant) {
        if (addButton) { addButton.disabled = true; qs('[data-add-label]', addButton).textContent = 'Unavailable'; }
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = 'Unavailable'; }
        return;
      }
      if (formId) formId.value = variant.id;
      const money = (cents) => {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100); }
        catch (_) { return `$${(cents / 100).toFixed(2)}`; }
      };
      const price = qs('[data-price]', this.root);
      const compare = qs('[data-compare-price]', this.root);
      if (price) price.textContent = money(variant.price);
      if (compare) {
        const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.hidden = !showCompare;
        if (showCompare) compare.textContent = money(variant.compare_at_price);
      }
      const stickyPrice = qs('[data-sticky-price]', this.root);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (addButton) { addButton.disabled = !variant.available; qs('[data-add-label]', addButton).textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      if (stickyAdd) { stickyAdd.disabled = !variant.available; stickyAdd.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      if (variant.featured_media_id) qs(`[data-media-thumb="${variant.featured_media_id}"]`, this.root)?.click();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }
  if (!customElements.get('variant-selector')) customElements.define('variant-selector', VariantSelector);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { closeMenu(); closeFilters(); }
  });
})();
